<div class="modal-header local-header">
	<h4 class="modal-title synchpc-primary" id="modal-title" >About Us</h4>
	<i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" mat-dialog-close title="Close"></i>
</div>
<div class="modal-body local-header" style=" height: 34vh; max-height: 34vh ; " >
	<div style="display: inline-flex" class="aboutUsMid">
		<img src="../../../assets/images/syncious/synchpc_logo.png"
				 height="50"
				 width="60" />
		<span class="synchpc-primary"
					style="font-size: 3rem; font-weight: 700; margin: 15px;">SyncHPC</span>
	</div>
	<br />
	<br />
	<mat-divider></mat-divider>
	<br />
	<div class="aboutUsMid">
		<div>
			<b>SyncHPC</b>
			<br />
			{{ syncHpcVersion }}
			<br />
			<span *ngIf="toShowLabel">Syncious Systems Private Limited.</span><span> All Rights Reserved.</span>
		</div>
		<div>
			<button class="syncAutoBtn bi bi-download"
							(click)="downloadSyncVdiServiceWin()"
							title='Windows Service To Monitor Remote Sessions And Workstation. Refer `Readme.txt` Inside Package'>
				SyncVDI Service Winx64
			</button>
			<br />
			<button class="syncAutoBtn bi bi-download mt-1"
							(click)="downloadSyncVdiServiceLin()"
							title='Linux Service To Monitor Remote Sessions And Workstation. Refer `Readme.txt` Inside Package'>
				SyncVDI Service Linx64
			</button>
			<br />
			<button class="syncAutoBtn bi bi-download mt-1"
							(click)="downloadSyncVdiGateway()"
							title='SyncVDI Gateway download'>
				SyncVDI Gateway
			</button>
		</div>
		<div>
			<button class="syncAutoBtn bi bi-download"
							(click)="downloadSyncVdiClient()"
							title='Windows Desktop Client For VDI'>
				SyncVDI Desktop Client
			</button>
			<br />
			<button class="syncAutoBtn bi bi-download mt-1"
							(click)="downloadFile()"
							title='Windows Service To Download Job Data From SyncStore. Refer `Readme.txt` Inside Package'>
				Auto-Download Service
			</button>
		</div>
	</div>
	<br />
	<mat-divider></mat-divider>
	<br />
	<p>
		&#169; {{ currentYear }} - {{ toShowLabel || 'Syncious Systems Private Limited'}} | Trademarks and brands are
		the properties of their respective owners.
	</p>
</div>
